
  import '/vercel/path0/docs/index.md?watch=parent';
  export const texts = [{"value":"请访问 ","paraId":0,"tocIndex":1},{"value":"GitHub","paraId":0,"tocIndex":1},{"value":" 或加入讨论群：","paraId":0,"tocIndex":1},{"value":"\n  ","paraId":1}];
  